import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, lastValueFrom } from 'rxjs';

import { AppService } from '../../../services';



@Injectable()
export class UserActivitiesService {
  private http = inject(HttpClient);
  private _appService = inject(AppService);


  private headers = new HttpHeaders();

  private suiteUrl = this._appService.getServerBaseUrl + '/suite';
  private calendarUrl = this._appService.getServerBaseUrl + '/calendar';
  private activityUrl = this._appService.getServerBaseUrl + '/activity';
  private userCalendarUrl = this._appService.getServerBaseUrl + '/usercalendar';
  private serviceUrl = this._appService.getServerBaseUrl + '/party';

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {

    this.headers.append("Accept", "*/*")
    this.headers.append("Content-Type", "application/json")
  }

  getUserActivities(): Observable<any> {

    const url = `${this.calendarUrl}/useractivities`;
    let options = { headers: this.headers, withCredentials: true };
    let params = { take: 20, justMine: true }

    return this.http
      .post(url, params, options)
  }

  getUserActivitiesFil(from: String, to: String, state: String, typologies: any[]): Observable<any> {
    const url = `${this.calendarUrl}/useractivities`;
    let options = { headers: this.headers, withCredentials: true };

    let params = {
      initialDate: from, finalDate: to,
      workingState: state, typology: typologies, justMine: true
    }

    return this.http.post(
      url, params, options)

  }

  getActivityTypologies(): Observable<any> {

    const url = `${this.activityUrl}/typologies`;
    let options = { headers: this.headers, withCredentials: true };

    return this.http.get(
      url, options)
  }

  getCandidatesOwners(calendarId: string): Observable<any> {

    let options = { headers: this.headers, withCredentials: true };
    const url = `${this.userCalendarUrl}/owners?calendarId=${calendarId}`;

    return this.http
      .get(url, options)

  }

  saveActivity(activity: any): Promise<any> {

    let options = { headers: this.headers, withCredentials: true };

    return lastValueFrom(this.http.put(this.activityUrl, activity, options)).then(() => true)
  }

  createActivity(): Observable<any> {

    const url = `${this.activityUrl}/create`;
    let options = { headers: this.headers, withCredentials: true };

    return this.http
      .get(url, options)

  }

  getActivity(id: String): Observable<any> {

    const url = `${this.activityUrl}/${id}`;
    let options = { headers: this.headers, withCredentials: true };

    return this.http
      .get(url, options)

  }

  getCalendars(): Observable<any> {

    const url = `${this.userCalendarUrl}/calendars`;
    let options = { headers: this.headers, withCredentials: true };

    return this.http
      .get(url, options)

  }

  getAllOwners(): Observable<any> {

    let options = { headers: this.headers, withCredentials: true };
    const url = `${this.suiteUrl}/ownerusers`;

    return this.http
      .get(url, options)

  }

  search(term: String, state: any, items: String[], subjectId: String): Observable<any> {

    const url = `${this.serviceUrl}/search`;
    let options = { headers: this.headers, withCredentials: true };

    let params = { term: term, obsolete: state, subjectId: subjectId, items }

    return this.http
      .post(url, params, options)

  }

  getRealtionTypologies(): Observable<any> {

    const baseUrl = this._appService.getServerBaseUrl;
    const url = `${baseUrl}/owner/relationtypologies/1`;

    let options = { headers: this.headers, withCredentials: true };

    return this.http.get(
      url, options)

  }

  savePreferredTypologies(items: String[]): Promise<any> {

    const baseUrl = this._appService.getServerBaseUrl;
    const url = `${baseUrl}/owner/saveuserreltypes`;

    let params = { items }
    let options = { headers: this.headers, withCredentials: true };

    return lastValueFrom(this.http.post(url, params, options));
  }
}
